import { render } from "solid-js/web";
import App from "./App";
import "./App.css";

const env = (import.meta as ImportMeta & {
  env?: Record<string, string | undefined>;
}).env ?? {};

const injectedAdminConfig = {
  controlPlaneBaseUrl: env.VITE_ADMIN_CONTROL_PLANE_URL,
  managedAppBaseUrl: env.VITE_MANAGED_APP_URL,
  webAppBaseUrl: env.VITE_MANAGED_WEB_URL,
};

if (injectedAdminConfig.controlPlaneBaseUrl || injectedAdminConfig.managedAppBaseUrl) {
  (window as Window & typeof globalThis).__adminConfig = {
    ...(window as Window & typeof globalThis).__adminConfig,
    ...injectedAdminConfig,
  };
}

render(() => <App />, document.getElementById("root")!);
